var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.isMobileView ? 'Stack' : 'HStack', {
    tag: "component",
    staticClass: "gap-2"
  }, [_c('b-form-group', {
    staticClass: "flex-1 mb-0",
    attrs: {
      "label": _vm.$t('utils.flightsSchedule.filters.stationType'),
      "label-for": "station-type-select"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "station-type-select",
      "options": _vm.stationTypeSupported,
      "searchable": "",
      "filterable": "",
      "clearable": false,
      "value": _vm.stationTypeFilter,
      "placeholder": _vm.$t('placeholderSelect'),
      "reduce": function reduce(val) {
        return val;
      }
    },
    on: {
      "input": function input(val) {
        _vm.$emit('update:stationTypeFilter', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "selected-option",
      fn: function fn(_ref) {
        var label = _ref.label;
        return [_vm._v(" " + _vm._s(_vm.$t("utils.flightsSchedule.stationType.".concat(label)) || label) + " ")];
      }
    }, {
      key: "option",
      fn: function fn(_ref2) {
        var label = _ref2.label;
        return [_vm._v(" " + _vm._s(_vm.$t("utils.flightsSchedule.stationType.".concat(label)) || label) + " ")];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "flex-1 mb-0",
    attrs: {
      "label": _vm.$t('utils.flightsSchedule.filters.tripType'),
      "label-for": "trip-type-select"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "trip-type-select",
      "options": _vm.TRIP_TYPE_OPTIONS,
      "searchable": "",
      "filterable": "",
      "clearable": false,
      "value": _vm.tripTypeFilter,
      "placeholder": _vm.$t('placeholderSelect'),
      "reduce": function reduce(val) {
        return val.value;
      }
    },
    on: {
      "input": function input(val) {
        _vm.$emit('update:tripTypeFilter', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "selected-option",
      fn: function fn(_ref3) {
        var label = _ref3.label;
        return [_vm._v(" " + _vm._s(_vm.$t("utils.flightsSchedule.tripType.".concat(label)) || label) + " ")];
      }
    }, {
      key: "option",
      fn: function fn(_ref4) {
        var label = _ref4.label;
        return [_vm._v(" " + _vm._s(_vm.$t("utils.flightsSchedule.tripType.".concat(label)) || label) + " ")];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "flex-1 mb-0",
    attrs: {
      "label": _vm.$t('utils.flightsSchedule.filters.departure'),
      "label-for": "departure-select"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "departure-select",
      "options": _vm.airportSupported,
      "searchable": "",
      "filterable": "",
      "label": "code",
      "clearable": false,
      "value": _vm.departureFilter,
      "placeholder": _vm.$t('placeholderSelect'),
      "reduce": function reduce(val) {
        return val.code;
      }
    },
    on: {
      "input": function input(val) {
        _vm.$emit('update:departureFilter', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "selected-option",
      fn: function fn(_ref5) {
        var code = _ref5.code,
          name = _ref5.name;
        return [_c('HStack', [_vm._v(" " + _vm._s(name || _vm.$t("utils.flightsSchedule.airport.".concat(code)) || code) + " "), _c('span', [_vm._v(" (" + _vm._s(code) + ") ")])])];
      }
    }, {
      key: "option",
      fn: function fn(_ref6) {
        var code = _ref6.code,
          name = _ref6.name;
        return [_c('HStack', [_vm._v(" " + _vm._s(name || _vm.$t("utils.flightsSchedule.airport.".concat(code)) || code) + " "), _c('span', [_vm._v(" (" + _vm._s(code) + ") ")])])];
      }
    }])
  })], 1), _c('IAmDatePicker', {
    staticClass: "flex-1 mb-0",
    attrs: {
      "id": "departure-date-picker",
      "date": _vm.departureDateFilter,
      "placeholder": _vm.$t('placeholderSelect'),
      "label": _vm.$t('utils.flightsSchedule.filters.departureDate'),
      "configs": {
        altInputClass: 'form-control'
      },
      "customClass": ""
    },
    on: {
      "input": function input(val) {
        if (val) {
          _vm.$emit('update:departureDateFilter', val);
        }
      }
    }
  }), _c('b-form-group', {
    staticClass: "flex-1 mb-0",
    attrs: {
      "label": _vm.$t('utils.flightsSchedule.filters.departureHour'),
      "label-for": "departure-hour-select"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "departure-hour-select",
      "options": _vm.DEPARTURE_HOUR_OPTIONS,
      "searchable": "",
      "filterable": "",
      "clearable": false,
      "value": _vm.departureHourFilter,
      "placeholder": _vm.$t('placeholderSelect'),
      "reduce": function reduce(val) {
        return val.value;
      }
    },
    on: {
      "input": function input(val) {
        _vm.$emit('update:departureHourFilter', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "selected-option",
      fn: function fn(_ref7) {
        var label = _ref7.label;
        return [_vm._v(" " + _vm._s(label === 'ALL' ? _vm.$t('All') : label) + " ")];
      }
    }, {
      key: "option",
      fn: function fn(_ref8) {
        var label = _ref8.label;
        return [_vm._v(" " + _vm._s(label === 'ALL' ? _vm.$t('All') : label) + " ")];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }